export default "__VITE_ASSET__DK1xyMho__"